export default __webpack_public_path__ + "static/stargazer-c14-e6c8090329caec7a2b0fc2e6856988be.png";